import { useEffect, useState } from "react";
import { X, Loader2, CheckCircle2, Clock, XCircle } from "lucide-react";
import apiClient from "@/lib/api";
import { formatRupiah } from "@/components/booking/bookingMeta";

const PURPOSE_LABELS = { room: "Harga Kamar", deposit: "Deposit", room_and_deposit: "Kamar + Deposit" };
const STATUS_META = {
  paid: { label: "Berhasil", icon: CheckCircle2, cls: "text-emerald-600" },
  pending: { label: "Menunggu", icon: Clock, cls: "text-amber-600" },
  failed: { label: "Gagal", icon: XCircle, cls: "text-rose-600" },
  expired: { label: "Kedaluwarsa", icon: XCircle, cls: "text-muted-foreground" },
  cancelled: { label: "Dibatalkan", icon: XCircle, cls: "text-muted-foreground" },
};

export default function PaymentHistoryModal({ open, booking, onClose }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!open || !booking) return;
    setLoading(true);
    apiClient.get(`/payments/booking/${booking.id}`)
      .then((r) => setRows(r.data || []))
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  }, [open, booking]);

  if (!open || !booking) return null;

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/50 p-4" data-testid="payment-history-modal">
      <div className="w-full max-w-md rounded-2xl bg-card border border-border shadow-2xl max-h-[85vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-border">
          <h2 className="font-heading text-lg font-bold">Riwayat Pembayaran</h2>
          <button onClick={onClose} data-testid="payment-history-close" className="text-muted-foreground hover:text-foreground"><X size={20} /></button>
        </div>
        <div className="p-4 overflow-y-auto">
          {loading ? (
            <div className="grid place-items-center py-10"><Loader2 className="animate-spin text-primary" size={24} /></div>
          ) : rows.length === 0 ? (
            <p className="text-sm text-muted-foreground text-center py-8" data-testid="payment-history-empty">Belum ada transaksi pembayaran.</p>
          ) : (
            <div className="space-y-2" data-testid="payment-history-list">
              {rows.map((p, i) => {
                const meta = STATUS_META[p.status] || STATUS_META.pending;
                const Icon = meta.icon;
                return (
                  <div key={p.id} data-testid={`payment-history-${i}`} className="flex items-center gap-3 rounded-xl border border-border bg-background px-3 py-2.5">
                    <span className="text-xs text-muted-foreground w-8">#{String(i + 1).padStart(3, "0")}</span>
                    <span className="flex-1">
                      <span className="block text-sm font-semibold">{formatRupiah(p.amount)}</span>
                      <span className="block text-xs text-muted-foreground">{PURPOSE_LABELS[p.payment_purpose] || p.payment_purpose}{p.payment_method ? ` · ${p.payment_method}` : ""}</span>
                    </span>
                    <span className={`inline-flex items-center gap-1 text-xs font-semibold ${meta.cls}`} data-testid={`payment-history-${i}-status`}>
                      <Icon size={14} /> {meta.label}
                    </span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
